
import Route from "./Route";
import { useContext, useState } from 'react';
import NavigationContext from '../context/Navigation';
import Dropdown from 'react-bootstrap/Dropdown';
import { TiThMenuOutline } from "react-icons/ti";
import NavDropdown from 'react-bootstrap/NavDropdown';

function Header({ }) {

    const { Navigate, currentPath } = useContext(NavigationContext);

    return (
        <header className="App-header flex w-full justify-between items-center max-w-7xl pt-3 px-3 gap-2">
            <div className="font-bold text-3xl"><span><span className="italic text-orange-500">Basket </span>Now</span></div>
            <div className=" flex overflow-auto gap-1">
                <button className="button p-2 w-full text-center text-xl " onClick={() => Navigate('/login')} >Login</button>
                <button className="button p-2 w-full text-xl " onClick={() => Navigate('/register')}>Register</button>
            </div>
        </header>
    )

}

export default Header